import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { Configuration } from '../../model/configuration';

/** BFF /bootstrap response. Collapses what used to be 4 startup requests
 *  (/auth/me, /session, /ui-config, /navigation-rules.json) into a single
 *  roundtrip. `permittedRoutes` is pre-resolved server-side from the user's
 *  authorities — the navigation-rules.json never reaches the browser. */
export interface BootstrapPayload {
  authenticated: boolean;
  userId?: string | null;
  authorities?: string[];
  sessionId?: string | null;
  uiConfig?: Configuration;
  /** Every route that has a rule entry. Routes NOT in this list have no
   *  rule at all → default-allow (matches the pre-bootstrap client logic). */
  knownRoutes?: string[];
  /** The subset of knownRoutes the user is allowed to access. */
  permittedRoutes?: string[];
}

@Injectable({ providedIn: 'root' })
export class BootstrapService {

  private cached$: Observable<BootstrapPayload> | null = null;

  constructor(private http: HttpClient) {}

  /** Cached for the lifetime of the SPA. The bootstrap payload doesn't
   *  change after login — re-requesting would only waste a roundtrip. */
  load(): Observable<BootstrapPayload> {
    if (!this.cached$) {
      this.cached$ = this.http
        .get<BootstrapPayload>('/bootstrap', { withCredentials: true })
        .pipe(shareReplay(1));
    }
    return this.cached$;
  }

  /** Clear the cache so the next load() does a fresh fetch. Call after
   *  logout if you ever need the SPA to re-bootstrap without a hard reload. */
  invalidate(): void {
    this.cached$ = null;
  }
}
